/** Align with backend JSON (camelCase string values). */
export type HabitIcon = 'sun' | 'workout' | 'book'

/** Mirrors backend HabitDto. */
export type HabitDto = {
  id: string
  title: string
  category?: string | null
  icon: HabitIcon
  createdAt: string
  archivedAt?: string | null
}

export type CreateHabitRequest = {
  title: string
  category?: string
  icon?: HabitIcon
}

/** PATCH body: include keys to change; use null to clear optional fields. */
export type UpdateHabitRequest = {
  title?: string | null
  category?: string | null
  icon?: HabitIcon | null
  archivedAt?: string | null
}

export type HabitCompletionDto = {
  habitId: string
  date: string
  completedAt: string
}

export type HabitWeekDto = {
  weekStart: string
  completions: HabitCompletionDto[]
}

export type Habit = {
  id: string
  title: string
  category?: string
  icon: HabitIcon
  createdAt: string
  archivedAt?: string
}

export type HabitsState = {
  items: Habit[]
  /** weekStart (Monday key) → habitId → completed date keys for that week */
  completionsByWeek: Record<string, Record<string, string[]>>
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error?: string
}

export function mapHabitDto(d: HabitDto): Habit {
  return {
    id: d.id,
    title: d.title,
    category: d.category ?? undefined,
    icon: d.icon,
    createdAt: d.createdAt,
    archivedAt: d.archivedAt ?? undefined,
  }
}

export function completionsDtoToByHabit(completions: HabitCompletionDto[]): Record<string, string[]> {
  const byHabit: Record<string, string[]> = {}
  for (const c of completions) {
    if (!byHabit[c.habitId]) byHabit[c.habitId] = []
    byHabit[c.habitId].push(c.date)
  }
  for (const k of Object.keys(byHabit)) {
    byHabit[k].sort()
  }
  return byHabit
}
